import { render, staticRenderFns } from "./ProPatientsCAnamnesisPage.vue?vue&type=template&id=0df022ec"
import script from "./ProPatientsCAnamnesisPage.vue?vue&type=script&lang=js"
export * from "./ProPatientsCAnamnesisPage.vue?vue&type=script&lang=js"
import style0 from "./ProPatientsCAnamnesisPage.vue?vue&type=style&index=0&id=0df022ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports